import type { SectionTheme } from "#lib/web-ui/primitives/index.js";

export type TeamMember = {
	displayName: string;
	title: string;
	headshot: string | null;
	bio: string | null;
};

export const defaultMembers: TeamMember[] = [
	{
		displayName: "Jane Smith",
		title: "CEO & Founder",
		headshot: null,
		bio: "A visionary leader with decades of industry experience driving innovation and growth."
	},
	{
		displayName: "John Doe",
		title: "VP of Operations",
		headshot: null,
		bio: "Oversees day-to-day operations ensuring excellence across all departments."
	},
	{
		displayName: "Sarah Johnson",
		title: "Director of Strategy",
		headshot: null,
		bio: "Develops and executes strategic initiatives that position the company for long-term success."
	}
];

export type TeamBaseProps = {
	theme?: SectionTheme;
	id?: string;
	label?: string;
	title?: string;
	subtitle?: string;
	members?: TeamMember[];
};

export const teamDefaults = {
	theme: "light" as SectionTheme,
	id: "team",
	label: "Our Team",
	title: "Meet the Team",
	subtitle: "The people behind our success."
};
